import type { Account } from '@ps/web-core-store';

import { composeValidatorsWithThreshold } from '../composeValidatorsWithThreshold/composeValidatorsWithThreshold';
import { mustNotContain } from '../mustNotContain/mustNotContain';
import type { Error } from '../types';

export const mustNotContainName = (
  { firstName = '', lastName = '' }: Partial<Account>,
  message?: Error['message']
) => {
  const indexOfSecondLastName = lastName.lastIndexOf(' ');
  const names =
    indexOfSecondLastName === -1
      ? [lastName]
      : [
          lastName.substring(indexOfSecondLastName + 1),
          lastName.substring(0, indexOfSecondLastName)
        ];
  names.push(firstName);

  return composeValidatorsWithThreshold(
    [
      ...names.map((name) => mustNotContain(name, message)),
      ...names.map((name) => mustNotContain(name.split(/[\s|-]+/).join(''), message))
    ],
    message
  );
};
